import React from 'react';
import g from 'glamorous';

import { maxLayoutWidth } from '../utils/layout-units';

const Banner = g.div({
  width: '100vw',
  maxWidth: maxLayoutWidth,
  height: '30vw',
  minHeight: '200px',
  maxHeight: '320px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  boxShadow: '0 0 1px 0 rgba(0, 0, 0, 0.2)',
});

export default ({ imageUrl }) => (
  <Banner css={{ backgroundImage: `url(${imageUrl})` }}/>
);



// WEBPACK FOOTER //
// ./src/components/banner.js